import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import axios from 'axios'; // TODO: rimuovere, usare api
import {
  XMarkIcon,
  BuildingOfficeIcon,
  UsersIcon,
  CurrencyEuroIcon,
  UserIcon,
  ExclamationTriangleIcon,
  CheckCircleIcon,
  InformationCircleIcon,
  ClipboardIcon,
  PlusIcon,
  PencilIcon,
  TrashIcon,
  CheckIcon,
  GlobeAltIcon,
  KeyIcon,
  ChevronDownIcon,
  ChevronRightIcon
} from '@heroicons/react/24/outline';

const GestoreNodi = ({
  isOpen,
  onClose,
  onSave,
  tipo = 'create', // 'create' | 'edit'
  nodoIniziale = null,
  parentNodo = null,
  tipiNodo = []
}) => {
  const [formData, setFormData] = useState({
    nome: '',
    tipo: 'agente',
    utenteId: '',
    provvigionePercentuale: '',
    provvigioneFissa: '',
    descrizione: '',
    modalitaProvvigione: 'percentuale', // 'percentuale' | 'fissa'
    // Campi specifici per Sito Vetrina
    fonteId: '',
    dettaglioProvenienzaId: '',
    urlSito: '',
    apiKey: ''
  });

  const [utentiDisponibili, setUtentiDisponibili] = useState([]);
  const [fontiDisponibili, setFontiDisponibili] = useState([]);
  const [dettagliDisponibili, setDettagliDisponibili] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errori, setErrori] = useState({});
  const [validazione, setValidazione] = useState({});
  const [searchUtente, setSearchUtente] = useState('');
  const [showDropdownUtenti, setShowDropdownUtenti] = useState(false);
  const [modalAperto, setModalAperto] = useState(false);
  const [modalTipo, setModalTipo] = useState('aggiungi'); // 'aggiungi' o 'modifica'
  const [sezioniEspanse, setSezioniEspanse] = useState({
    informazioniBase: true,
    provvigioni: true,
    sitoVetrina: true,
    avanzate: false
  });

  // Inizializza il form
  useEffect(() => {
    if (tipo === 'edit' && nodoIniziale) {
      console.log('DEBUG GestoreNodi - APERTURA MODALE EDIT');
      console.log('nodoIniziale:', nodoIniziale);
      console.log('tipiNodo disponibili:', tipiNodo);
      // Controllo chiavi principali
      const chiaviForm = [
        'nome', 'tipo', 'utenteId', 'provvigioneTipo', 'provvigioneValore',
        'descrizione', 'fonteId', 'dettaglioProvenienzaId', 'urlSito', 'apiKey'
      ];
      chiaviForm.forEach(k => {
        if (!(k in nodoIniziale)) {
          console.warn(`⚠️ Chiave mancante in nodoIniziale: ${k}`);
        }
      });
      if (!tipiNodo.find(t => t.id === (nodoIniziale.tipo || nodoIniziale.tipoNodo))) {
        console.warn('⚠️ Il tipo del nodo non è presente tra i tipiNodo:', nodoIniziale.tipo || nodoIniziale.tipoNodo);
      }
      setFormData({
        nome: nodoIniziale.nome || '',
        tipo: nodoIniziale.tipo || nodoIniziale.tipoNodo || 'agente',
        utenteId: nodoIniziale.utenteId || nodoIniziale.userId || '',
        provvigionePercentuale: nodoIniziale.provvigioneTipo === 'percentuale' ? nodoIniziale.provvigioneValore || '' : '',
        provvigioneFissa: nodoIniziale.provvigioneTipo === 'fisso' ? nodoIniziale.provvigioneValore || '' : '',
        descrizione: nodoIniziale.descrizione || '',
        modalitaProvvigione: nodoIniziale.provvigioneTipo || 'percentuale',
        fonteId: nodoIniziale.fonteId || '',
        dettaglioProvenienzaId: nodoIniziale.dettaglioProvenienzaId || '',
        urlSito: nodoIniziale.urlSito || '',
        apiKey: nodoIniziale.apiKey || ''
      });
      setTimeout(() => {
        console.log('DEBUG GestoreNodi - formData dopo set:', formData);
      }, 100);
    } else {
      // Modalità creazione - imposta il tipo predefinito se c'è un parent
      let tipoDefault = 'agente';
      if (!parentNodo) {
        tipoDefault = 'agenzia_primaria';
      } else if (parentNodo.tipo === 'agenzia_primaria') {
        tipoDefault = 'team_leader';
      }
      
      setFormData(prev => ({
        ...prev,
        tipo: nodoIniziale?.tipo || tipoDefault
      }));
    }
  }, [tipo, nodoIniziale, parentNodo]);

  // Carica utenti disponibili quando cambia il tipo di nodo
  useEffect(() => {
    if (isOpen) {
      caricaUtentiDisponibili();
    }
  }, [isOpen, formData.tipo]); // Ricarica quando cambia il tipo di nodo

  // Carica utenti disponibili
  useEffect(() => {
    if (isOpen) {
      caricaFontiDisponibili();
    }
  }, [isOpen]);

  // Carica dettagli quando cambia la fonte
  useEffect(() => {
    if (formData.fonteId) {
      caricaDettagliProvenienza(formData.fonteId);
    } else {
      setDettagliDisponibili([]);
      setFormData(prev => ({ ...prev, dettaglioProvenienzaId: '' }));
    }
  }, [formData.fonteId]);

  // Chiudi dropdown quando si clicca fuori
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showDropdownUtenti && !event.target.closest('.dropdown-utenti')) {
        setShowDropdownUtenti(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDropdownUtenti]);

  // Validazione in tempo reale
  useEffect(() => {
    validaForm();
  }, [formData]);

  const caricaUtentiDisponibili = async () => {
    try {
      console.log(`🔍 GestoreNodi - Caricamento utenti per tipo nodo: ${formData.tipo}`);
      
      // Passa il tipo di nodo come parametro per filtrare gli utenti appropriati
      const params = new URLSearchParams();
      if (formData.tipo) {
        params.append('tipoNodo', formData.tipo);
      }
      
      const url = `/utenti/disponibili-rete?${params.toString()}`;
      console.log(`🌐 GestoreNodi - URL chiamata: ${url}`);
      
      const response = await api.get(url);
      console.log(`📥 GestoreNodi - Risposta ricevuta:`, response.data);
      console.log(`👤 GestoreNodi - Numero utenti ricevuti: ${response.data.data?.length || 0}`);
      
      let utenti = response.data.data || [];
      // In modalità edit, se l'utente assegnato non è tra quelli disponibili, aggiungilo forzatamente
      if (tipo === 'edit' && nodoIniziale && nodoIniziale.utenteId) {
        const giaPresente = utenti.some(u => u.id === parseInt(nodoIniziale.utenteId));
        if (!giaPresente) {
          let utenteDettagli = {
            id: parseInt(nodoIniziale.utenteId),
            nome: nodoIniziale.utenteNome || 'Utente assegnato',
            cognome: nodoIniziale.utenteCognome || '',
            username: nodoIniziale.utenteUsername || '',
            email: nodoIniziale.utenteEmail || '',
            role: nodoIniziale.utenteRuolo || '',
            stato: 'attivo' // Lo stato dell'utente già assegnato è sempre 'attivo' in questo contesto
          };
          // Se mancano i dati principali, recuperali via API
          if (!nodoIniziale.utenteNome || !nodoIniziale.utenteCognome || !nodoIniziale.utenteEmail) {
            try {
              console.log(`⏳ Tentativo di recupero dettagli per utenteId: ${nodoIniziale.utenteId}`);
              const userResp = await api.get(`/utenti/${nodoIniziale.utenteId}`);
              console.log('📬 Risposta API per dettagli utente:', userResp); // Log the full response
              if (userResp.data && (userResp.data.data || userResp.data.dati)) {
                const datiUtente = userResp.data.data || userResp.data.dati;
                utenteDettagli = {
                  id: datiUtente.id,
                  nome: datiUtente.nome || 'Utente assegnato',
                  cognome: datiUtente.cognome || '',
                  username: datiUtente.username || '',
                  email: datiUtente.email || '',
                  role: datiUtente.role || '',
                  stato: 'attivo' // Forza lo stato ad 'attivo' per la UI
                };
                console.log('✅ Dati utente assegnato recuperati da API:', utenteDettagli);
              } else {
                console.warn('⚠️ La risposta API non contiene userResp.data.data né userResp.data.dati. Struttura risposta:', userResp.data);
              }
            } catch (err) {
              console.error(`❌ Errore grave nel recupero dettagli utente ${nodoIniziale.utenteId}:`, err.response || err.message);
            }
          }
          utenti = [utenteDettagli, ...utenti];
          console.log('👤 Utente assegnato aggiunto forzatamente alla lista:', utenti[0]);
        }
      }
      setUtentiDisponibili(utenti);
      
      // Se l'utente selezionato non è più nella lista (cambiando tipo), resetta la selezione
      if (formData.utenteId && utenti) {
        const utenteValido = utenti.find(u => u.id === parseInt(formData.utenteId));
        if (!utenteValido) {
          console.log(`⚠️ GestoreNodi - Reset utente selezionato: non più valido per il tipo ${formData.tipo}`);
          setFormData(prev => ({ ...prev, utenteId: '' }));
          setSearchUtente('');
        }
      }
    } catch (error) {
      console.error('❌ GestoreNodi - Errore caricamento utenti:', error);
      setUtentiDisponibili([]);
    }
  };

  const caricaFontiDisponibili = async () => {
    try {
      const response = await api.get('/fonti/disponibili');
      setFontiDisponibili(response.data.data || []);
    } catch (error) {
      console.error('Errore caricamento fonti:', error);
    }
  };

  const caricaDettagliProvenienza = async (fonteId) => {
    try {
      const response = await api.get(`/dettagli-provenienza/${fonteId}`);
      setDettagliDisponibili(response.data.data || []);
    } catch (error) {
      console.error('Errore caricamento dettagli:', error);
    }
  };

  const validaForm = () => {
    const nuoviErrori = {};
    const nuovaValidazione = {};

    // Nome obbligatorio solo per agenzia_primaria
    if (formData.tipo === 'agenzia_primaria') {
      if (!formData.nome.trim()) {
        nuoviErrori.nome = 'Il nome è obbligatorio per l\'Agenzia Primaria';
      } else {
        nuovaValidazione.nome = 'ok';
      }
    }

    // Nome obbligatorio anche per sito_vetrina
    if (formData.tipo === 'sito_vetrina') {
      if (!formData.nome.trim()) {
        nuoviErrori.nome = 'Il nome è obbligatorio per il Sito Vetrina';
      } else {
        nuovaValidazione.nome = 'ok';
      }
    }

    // Utente opzionale per sito_vetrina, obbligatorio per altri
    if (formData.tipo !== 'sito_vetrina') {
      if (!formData.utenteId) {
        nuoviErrori.utenteId = 'Seleziona un utente';
      } else {
        nuovaValidazione.utenteId = 'ok';
      }
    } else {
      // Per sito vetrina l'utente è opzionale
      if (formData.utenteId) {
        nuovaValidazione.utenteId = 'ok';
      }
    }

    // Campi specifici per sito_vetrina
    if (formData.tipo === 'sito_vetrina') {
      if (!formData.fonteId) {
        nuoviErrori.fonteId = 'Seleziona una fonte di provenienza';
      } else {
        nuovaValidazione.fonteId = 'ok';
      }

      if (!formData.dettaglioProvenienzaId) {
        nuoviErrori.dettaglioProvenienzaId = 'Seleziona un dettaglio provenienza';
      } else {
        nuovaValidazione.dettaglioProvenienzaId = 'ok';
      }

      if (!formData.urlSito.trim()) {
        nuoviErrori.urlSito = 'L\'URL del sito è obbligatorio';
      } else {
        // Validazione URL
        try {
          new URL(formData.urlSito);
          nuovaValidazione.urlSito = 'ok';
        } catch {
          nuoviErrori.urlSito = 'Inserisci un URL valido (es. https://esempio.com)';
        }
      }
    }

    // Provvigione obbligatoria per tutti i tipi di nodo
    if (formData.modalitaProvvigione === 'percentuale') {
      if (!formData.provvigionePercentuale || formData.provvigionePercentuale <= 0 || formData.provvigionePercentuale > 100) {
        nuoviErrori.provvigionePercentuale = 'Inserisci una percentuale valida (1-100)';
      } else {
        nuovaValidazione.provvigionePercentuale = 'ok';
      }
    } else {
      if (!formData.provvigioneFissa || formData.provvigioneFissa <= 0) {
        nuoviErrori.provvigioneFissa = 'Inserisci un importo fisso valido';
      } else {
        nuovaValidazione.provvigioneFissa = 'ok';
      }
    }

    setErrori(nuoviErrori);
    setValidazione(nuovaValidazione);
    
    return Object.keys(nuoviErrori).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validaForm()) {
      return;
    }

    setLoading(true);

    try {
      const datiNodo = {
        tipo: formData.tipo,
        utenteId: formData.utenteId || null, // Può essere null per sito_vetrina
        descrizione: formData.descrizione?.trim() || null,
        // Provvigioni per tutti i tipi di nodo
        provvigionePercentuale: formData.modalitaProvvigione === 'percentuale' ? 
          parseFloat(formData.provvigionePercentuale) || 0 : null,
        provvigioneFissa: formData.modalitaProvvigione === 'fisso' ? 
          parseFloat(formData.provvigioneFissa) || 0 : null
      };

      // Campi specifici per sito_vetrina
      if (formData.tipo === 'sito_vetrina') {
        datiNodo.fonteId = parseInt(formData.fonteId);
        datiNodo.dettaglioProvenienzaId = parseInt(formData.dettaglioProvenienzaId);
        datiNodo.urlSito = formData.urlSito?.trim();
        datiNodo.apiKey = formData.apiKey?.trim() || '';
      }

      // Nome per tutti i tipi di nodo
      if (formData.nome?.trim()) {
        datiNodo.nome = formData.nome.trim();
      }

      // In modifica serve l'ID del nodo (altrimenti la PUT finisce su /nodi/undefined → 400)
      if (tipo === 'edit' && nodoIniziale?.id) {
        datiNodo.id = nodoIniziale.id;
      }

      await onSave(datiNodo, parentNodo?.id);
    } catch (error) {
      console.error('Errore salvataggio nodo:', error);
    } finally {
      setLoading(false);
    }
  };

  const getTipoNodo = (tipoId) => {
    return tipiNodo.find(t => t.id === tipoId) || tipiNodo[0];
  };

  // Filtra utenti in base alla ricerca
  const utentiFiltrati = utentiDisponibili.filter(utente => {
    const searchLower = searchUtente.toLowerCase();
    return (
      utente.nome.toLowerCase().includes(searchLower) ||
      utente.cognome.toLowerCase().includes(searchLower) ||
      utente.username.toLowerCase().includes(searchLower) ||
      utente.email.toLowerCase().includes(searchLower)
    );
  });

  // Mappatura tipo nodo -> ruolo per informazioni visive
  const getMappingTipoNodoRuolo = (tipoNodo) => {
    const mapping = {
      'agenzia_primaria': 'agenzia',
      'team_leader': 'team_leader', 
      'agente': 'subagente',
      'sito_vetrina': 'segnalatore'
    };
    return mapping[tipoNodo] || 'tutti';
  };

  const renderSelettoreUtente = () => {
    const hasError = errori.utenteId;
    const isValid = validazione.utenteId === 'ok';
    const isOptional = formData.tipo === 'sito_vetrina';
    const utenteSelezionato = utentiDisponibili.find(u => u.id === parseInt(formData.utenteId));
    const ruoloRichiesto = getMappingTipoNodoRuolo(formData.tipo);

    return (
      <div className="space-y-1">
        <label className="block text-sm font-medium text-gray-700">
          Utente Assegnato {!isOptional && <span className="text-red-500">*</span>}
          {isOptional && <span className="text-gray-500">(opzionale)</span>}
        </label>
        
        {/* Informazioni filtro applicato */}
        <div className="text-xs text-blue-600 bg-blue-50 border border-blue-200 rounded px-2 py-1 mb-2">
          <div className="flex items-center space-x-1">
            <InformationCircleIcon className="h-3 w-3" />
            <span>
              Mostra solo utenti <strong>inattivi</strong> con ruolo <strong>"{ruoloRichiesto}"</strong>
            </span>
          </div>
        </div>
        
        <div className="relative dropdown-utenti">
          {/* Input di ricerca */}
          <div className={`
            border rounded-lg ${hasError ? 'border-red-300 bg-red-50' : 
            isValid ? 'border-green-300 bg-green-50' : 'border-gray-300'}
          `}>
            {utenteSelezionato ? (
              // Utente selezionato
              <div className="flex items-center justify-between p-3">
                <div className="flex items-center space-x-3">
                  <div className="h-8 w-8 bg-blue-100 rounded-full flex items-center justify-center">
                    <UserIcon className="h-5 w-5 text-blue-600" />
                  </div>
                  <div>
                    <p className="font-medium text-gray-900 flex items-center space-x-2">
                      <span>{utenteSelezionato.nome} {utenteSelezionato.cognome}</span>
                      {utenteSelezionato.stato === 'attivo' ? (
                        <span className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded-full">
                          {utenteSelezionato.role} • attivo
                        </span>
                      ) : (
                      <span className="text-xs bg-orange-100 text-orange-700 px-2 py-1 rounded-full">
                        {utenteSelezionato.role} • inattivo
                      </span>
                      )}
                      {/* Nota se l'utente è quello già assegnato al nodo */}
                      {tipo === 'edit' && nodoIniziale && utenteSelezionato.id === parseInt(nodoIniziale.utenteId) && (
                        <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded-full ml-2">
                          assegnato a questo nodo
                        </span>
                      )}
                    </p>
                    <p className="text-sm text-gray-500">
                      {utenteSelezionato.username} • {utenteSelezionato.email}
                    </p>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => {
                    setFormData(prev => ({ ...prev, utenteId: '' }));
                    setSearchUtente('');
                  }}
                  className="text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <XMarkIcon className="h-5 w-5" />
                </button>
              </div>
            ) : (
              // Campo di ricerca
              <input
                type="text"
                value={searchUtente}
                onChange={(e) => {
                  setSearchUtente(e.target.value);
                  setShowDropdownUtenti(true);
                }}
                onFocus={() => setShowDropdownUtenti(true)}
                placeholder={`Cerca utente ${ruoloRichiesto} inattivo...`}
                className="w-full px-3 py-2 bg-transparent border-none rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                disabled={loading}
              />
            )}
          </div>

          {/* Dropdown risultati */}
          {!utenteSelezionato && showDropdownUtenti && (
            <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
              {utentiFiltrati.length > 0 ? (
                utentiFiltrati.map((utente) => (
                  <button
                    key={utente.id}
                    type="button"
                    onClick={() => {
                      setFormData(prev => ({ ...prev, utenteId: utente.id }));
                      setSearchUtente('');
                      setShowDropdownUtenti(false);
                    }}
                    className="w-full text-left p-3 hover:bg-gray-50 transition-colors flex items-center space-x-3"
                  >
                    <div className="h-8 w-8 bg-gray-100 rounded-full flex items-center justify-center">
                      <UserIcon className="h-5 w-5 text-gray-600" />
                    </div>
                    <div className="flex-1">
                      <p className="font-medium text-gray-900 flex items-center space-x-2">
                        <span>{utente.nome} {utente.cognome}</span>
                        <span className="text-xs bg-orange-100 text-orange-700 px-2 py-1 rounded-full">
                          {utente.role} • inattivo
                        </span>
                      </p>
                      <p className="text-sm text-gray-500">
                        {utente.username} • {utente.email}
                      </p>
                    </div>
                  </button>
                ))
              ) : utentiDisponibili.length === 0 ? (
                <div className="p-4 text-center">
                  <div className="text-gray-500 text-sm mb-2">
                    Nessun utente <strong>{ruoloRichiesto}</strong> inattivo disponibile
                  </div>
                  <div className="text-xs text-gray-400">
                    Tutti gli utenti con questo ruolo sono già attivi o non esistono
                  </div>
                </div>
              ) : (
                <div className="p-3 text-gray-500 text-center">
                  <div className="text-sm mb-1">Nessun utente trovato</div>
                  <div className="text-xs">Prova con un termine di ricerca diverso</div>
                </div>
              )}
            </div>
          )}
        </div>

        {hasError && (
          <p className="text-sm text-red-600 flex items-center space-x-1">
            <ExclamationTriangleIcon className="h-4 w-4" />
            <span>{hasError}</span>
          </p>
        )}
      </div>
    );
  };

  const renderCampoInput = (campo, label, tipo = 'text', placeholder = '', required = true) => {
    const hasError = errori[campo];
    const isValid = validazione[campo] === 'ok';

    return (
      <div className="space-y-1">
        <label className="block text-sm font-medium text-gray-700">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
        <div className="relative">
          <input
            type={tipo}
            value={formData[campo]}
            onChange={(e) => setFormData(prev => ({ ...prev, [campo]: e.target.value }))}
            placeholder={placeholder}
            className={`
              w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors
              ${hasError ? 'border-red-300 bg-red-50' : 
                isValid ? 'border-green-300 bg-green-50' : 'border-gray-300'}
            `}
            disabled={loading}
          />
          {isValid && (
            <CheckCircleIcon className="absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-green-500" />
          )}
        </div>
        {hasError && (
          <p className="text-sm text-red-600 flex items-center space-x-1">
            <ExclamationTriangleIcon className="h-4 w-4" />
            <span>{hasError}</span>
          </p>
        )}
      </div>
    );
  };

  const toggleSezione = (nomeSezione) => {
    setSezioniEspanse(prev => ({
      ...prev,
      [nomeSezione]: !prev[nomeSezione]
    }));
  };

  const renderAccordionSezione = (nomeSezione, titolo, icona, contenuto, isRequired = false) => {
    const isEspansa = sezioniEspanse[nomeSezione];
    
    return (
      <div className="border border-gray-200 rounded-lg overflow-hidden mb-4">
        <button
          type="button"
          onClick={() => toggleSezione(nomeSezione)}
          className="w-full px-4 py-3 bg-gray-50 hover:bg-gray-100 transition-colors flex items-center justify-between"
        >
          <div className="flex items-center space-x-3">
            <div className="p-1.5 bg-white rounded-lg shadow-sm">
              {icona}
            </div>
            <span className="font-medium text-gray-900">{titolo}</span>
            {isRequired && (
              <span className="text-red-500 text-sm">*</span>
            )}
          </div>
          <div className="text-gray-400">
            {isEspansa ? (
              <ChevronDownIcon className="h-5 w-5" />
            ) : (
              <ChevronRightIcon className="h-5 w-5" />
            )}
          </div>
        </button>
        
        {isEspansa && (
          <div className="p-4 bg-white border-t border-gray-200">
            {contenuto}
          </div>
        )}
      </div>
    );
  };

  const renderFormModifica = () => (
    <div className="space-y-6">
      {/* Form con Accordion */}
      <div className="space-y-4">
        {/* Sezione Informazioni Base */}
        {renderAccordionSezione(
          'informazioniBase',
          'Informazioni Base',
          <UserIcon className="h-4 w-4 text-blue-600" />,
          (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Tipo Nodo */}
              <div className="space-y-1">
                <label className="block text-sm font-medium text-gray-700">
                  Tipo Nodo <span className="text-red-500">*</span>
                </label>
                <select
                  value={formData.tipo}
                  onChange={(e) => setFormData(prev => ({ ...prev, tipo: e.target.value }))}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  disabled={loading}
                >
                  {tipiNodo.map((tipo) => (
                    <option key={tipo.id} value={tipo.id}>
                      {tipo.nome}
                    </option>
                  ))}
                </select>
                <p className="text-xs text-gray-500 mt-1">
                  {getTipoNodo(formData.tipo).descrizione}
                </p>
              </div>

              {/* Utente Assegnato */}
              <div className="space-y-1">
                {renderSelettoreUtente()}
              </div>

              {/* Nome Nodo - Per Agenzia Primaria e Sito Vetrina */}
              {(formData.tipo === 'agenzia_primaria' || formData.tipo === 'sito_vetrina') && (
                <div className="md:col-span-2">
                  {renderCampoInput(
                    'nome', 
                    formData.tipo === 'agenzia_primaria' ? 'Nome Agenzia' : 'Nome Sito Vetrina', 
                    'text', 
                    formData.tipo === 'agenzia_primaria' 
                      ? 'es. BRUMLY, Agenzia Milano Centro...' 
                      : 'es. Sito Vetrina Roma, Landing Page Milano...'
                  )}
                  <p className="text-xs text-gray-500 mt-1">
                    {formData.tipo === 'agenzia_primaria' 
                      ? 'Il nome identifica l\'agenzia nella rete e nei documenti'
                      : 'Il nome identifica il sito vetrina per il tracciamento lead'
                    }
                  </p>
                </div>
              )}

              {/* Info per nodi non-agenzia e non-sito-vetrina */}
              {formData.tipo !== 'agenzia_primaria' && formData.tipo !== 'sito_vetrina' && (
                <div className="md:col-span-2">
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <div className="flex items-start">
                      <InformationCircleIcon className="h-5 w-5 text-blue-500 mr-3 mt-0.5" />
                      <div>
                        <h3 className="text-blue-800 font-medium">Identificazione Automatica</h3>
                        <p className="text-blue-600 text-sm mt-1">
                          Per i {getTipoNodo(formData.tipo).nome.toLowerCase()}, il nome viene generato automaticamente 
                          dal nome e cognome dell'utente associato (es. "Team Leader Mario Rossi").
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Descrizione */}
              <div className="md:col-span-2 space-y-1">
                <label className="block text-sm font-medium text-gray-700">Descrizione</label>
                <textarea
                  value={formData.descrizione}
                  onChange={(e) => setFormData(prev => ({ ...prev, descrizione: e.target.value }))}
                  placeholder="Descrizione opzionale del nodo..."
                  rows={3}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  disabled={loading}
                />
              </div>
            </div>
          ),
          true
        )}

        {/* Sezione Configurazione Provvigioni */}
        {renderAccordionSezione(
          'provvigioni',
          'Configurazione Provvigioni',
          <CurrencyEuroIcon className="h-4 w-4 text-green-600" />,
          (
            <div className="space-y-4">
              {/* Info specifica per Sito Vetrina */}
              {formData.tipo === 'sito_vetrina' && (
                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
                  <div className="flex items-start">
                    <InformationCircleIcon className="h-5 w-5 text-yellow-500 mr-2 mt-0.5" />
                    <div>
                      <p className="text-yellow-700 text-sm">
                        I siti vetrina guadagnano quando il contratto diventa attivo. 
                        Configura la provvigione che verrà applicata per ogni lead convertito.
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {/* Modalità Provvigione */}
              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">Modalità Calcolo</label>
                <div className="flex space-x-4">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      value="percentuale"
                      checked={formData.modalitaProvvigione === 'percentuale'}
                      onChange={(e) => setFormData(prev => ({ 
                        ...prev, 
                        modalitaProvvigione: e.target.value,
                        provvigioneFissa: '' // Reset campo opposto
                      }))}
                      className="mr-2"
                      disabled={loading}
                    />
                    <span className="text-sm text-gray-700">Percentuale</span>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      value="fissa"
                      checked={formData.modalitaProvvigione === 'fissa'}
                      onChange={(e) => setFormData(prev => ({ 
                        ...prev, 
                        modalitaProvvigione: e.target.value,
                        provvigionePercentuale: '' // Reset campo opposto
                      }))}
                      className="mr-2"
                      disabled={loading}
                    />
                    <span className="text-sm text-gray-700">Importo Fisso</span>
                  </label>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Percentuale */}
                {formData.modalitaProvvigione === 'percentuale' && (
                  <div>
                    {renderCampoInput(
                      'provvigionePercentuale', 
                      'Percentuale (%)', 
                      'number', 
                      'es. 10.5',
                      true
                    )}
                    <p className="text-xs text-gray-500 mt-1">
                      {formData.tipo === 'sito_vetrina' 
                        ? 'Percentuale applicata quando il contratto diventa attivo'
                        : 'Percentuale applicata sul margine del livello superiore'
                      }
                    </p>
                  </div>
                )}

                {/* Importo Fisso */}
                {formData.modalitaProvvigione === 'fissa' && (
                  <div>
                    {renderCampoInput(
                      'provvigioneFissa', 
                      'Importo Fisso (€)', 
                      'number', 
                      'es. 250.00',
                      true
                    )}
                    <p className="text-xs text-gray-500 mt-1">
                      {formData.tipo === 'sito_vetrina' 
                        ? 'Importo fisso per ogni contratto attivato'
                        : 'Importo fisso per ogni operazione'
                      }
                    </p>
                  </div>
                )}
              </div>
            </div>
          )
        )}

        {/* Sezione Sito Vetrina (solo se tipo è sito_vetrina) */}
        {formData.tipo === 'sito_vetrina' && renderAccordionSezione(
          'sitoVetrina',
          'Configurazione Sito Vetrina',
          <BuildingOfficeIcon className="h-4 w-4 text-amber-600" />,
          (
            <div className="space-y-4">
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                <div className="flex items-start">
                  <InformationCircleIcon className="h-5 w-5 text-amber-500 mr-3 mt-0.5" />
                  <div>
                    <h4 className="text-sm font-medium text-amber-900">Configurazione Sito Vetrina</h4>
                    <p className="text-sm text-amber-700 mt-1">
                      Questi campi sono obbligatori per i nodi di tipo "Sito Vetrina".
                    </p>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Fonte */}
                <div className="space-y-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Fonte di Provenienza <span className="text-red-500">*</span>
                  </label>
                  <select
                    value={formData.fonteId}
                    onChange={(e) => setFormData(prev => ({ ...prev, fonteId: e.target.value }))}
                    className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                      errori.fonteId ? 'border-red-300' : 'border-gray-300'
                    }`}
                    disabled={loading}
                  >
                    <option value="">Seleziona una fonte</option>
                    {fontiDisponibili.map((fonte) => (
                      <option key={fonte.id} value={fonte.id}>
                        {fonte.descrizione}
                      </option>
                    ))}
                  </select>
                  {errori.fonteId && (
                    <p className="text-red-500 text-xs mt-1">{errori.fonteId}</p>
                  )}
                </div>

                {/* Dettaglio Provenienza */}
                <div className="space-y-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Dettaglio Provenienza <span className="text-red-500">*</span>
                  </label>
                  <select
                    value={formData.dettaglioProvenienzaId}
                    onChange={(e) => setFormData(prev => ({ ...prev, dettaglioProvenienzaId: e.target.value }))}
                    className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                      errori.dettaglioProvenienzaId ? 'border-red-300' : 'border-gray-300'
                    }`}
                    disabled={loading || !formData.fonteId}
                  >
                    <option value="">
                      {!formData.fonteId ? 'Prima seleziona una fonte' : 'Seleziona un dettaglio'}
                    </option>
                    {dettagliDisponibili.map((dettaglio) => (
                      <option key={dettaglio.id} value={dettaglio.id}>
                        {dettaglio.descrizione}
                      </option>
                    ))}
                  </select>
                  {errori.dettaglioProvenienzaId && (
                    <p className="text-red-500 text-xs mt-1">{errori.dettaglioProvenienzaId}</p>
                  )}
                </div>
              </div>

              {/* URL Sito */}
              <div>
                {renderCampoInput(
                  'urlSito', 
                  'URL del Sito Vetrina', 
                  'url', 
                  'https://esempio.com/landing-page'
                )}
                <p className="text-xs text-gray-500 mt-1">
                  URL completo del sito vetrina per il tracciamento delle conversioni
                </p>
              </div>

              {/* API Key */}
              <div>
                <div className="space-y-1">
                  <label className="block text-sm font-medium text-gray-700">
                    API Key <span className="text-gray-400">(generata automaticamente)</span>
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      value={formData.apiKey || 'Verrà generata automaticamente alla creazione'}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-500"
                      disabled
                    />
                    {formData.apiKey && (
                      <button
                        type="button"
                        onClick={() => navigator.clipboard.writeText(formData.apiKey)}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-blue-600 hover:text-blue-800"
                        title="Copia API Key"
                      >
                        <ClipboardIcon className="h-5 w-5" />
                      </button>
                    )}
                  </div>
                  <p className="text-xs text-gray-500">
                    L'API Key viene generata automaticamente e permette al sito di inviare lead al sistema
                  </p>
                </div>
              </div>
            </div>
          ),
          true
        )}

        {/* Sezione Avanzate (solo in modifica) */}
        {tipo === 'edit' && nodoIniziale && renderAccordionSezione(
          'avanzate',
          'Impostazioni Avanzate',
          <InformationCircleIcon className="h-4 w-4 text-gray-600" />,
          (
            <div className="space-y-4">
              <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                <div className="flex items-start">
                  <InformationCircleIcon className="h-5 w-5 text-gray-600 mr-3 mt-0.5" />
                  <div>
                    <h4 className="text-sm font-medium text-gray-900">Informazioni di Sistema</h4>
                    <p className="text-sm text-gray-600 mt-1">
                      Dati di sistema e metadati del nodo.
                    </p>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    ID Nodo
                  </label>
                  <input
                    type="text"
                    value={nodoIniziale.id}
                    readOnly
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-600"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Livello
                  </label>
                  <input
                    type="text"
                    value={nodoIniziale.livello || 'N/A'}
                    readOnly
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-600"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Data Creazione
                  </label>
                  <input
                    type="text"
                    value={nodoIniziale.createdAt ? new Date(nodoIniziale.createdAt).toLocaleDateString('it-IT') : 'N/A'}
                    readOnly
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-600"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Ultimo Aggiornamento
                  </label>
                  <input
                    type="text"
                    value={nodoIniziale.updatedAt ? new Date(nodoIniziale.updatedAt).toLocaleDateString('it-IT') : 'N/A'}
                    readOnly
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-600"
                  />
                </div>
              </div>
            </div>
          )
        )}
      </div>

      {/* Azioni */}
      <div className="flex items-center justify-end space-x-3 pt-6 border-t border-gray-200">
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          disabled={loading}
        >
          Annulla
        </button>
        
        <button
          type="submit"
          className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2 disabled:opacity-50"
          disabled={loading || Object.keys(errori).length > 0}
        >
          {loading && (
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
          )}
          <span>{tipo === 'create' ? 'Crea Nodo' : 'Salva Modifiche'}</span>
        </button>
      </div>
    </div>
  );

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-blue-100 rounded-lg">
              {tipo === 'create' ? (
                <BuildingOfficeIcon className="h-6 w-6 text-blue-600" />
              ) : (
                <UsersIcon className="h-6 w-6 text-blue-600" />
              )}
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-900">
                {tipo === 'create' ? 'Crea Nuovo Nodo' : 'Modifica Nodo'}
              </h2>
              <p className="text-gray-600">
                {parentNodo ? `Sotto: ${parentNodo.nome}` : 'Nodo radice della rete'}
              </p>
            </div>
          </div>
          
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            disabled={loading}
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          {/* Errore generale */}
          {errori.generale && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
              <div className="flex items-start">
                <ExclamationTriangleIcon className="h-5 w-5 text-red-500 mr-3 mt-0.5" />
                <div>
                  <h3 className="text-red-800 font-medium">Errore</h3>
                  <p className="text-red-600 text-sm mt-1">{errori.generale}</p>
                </div>
              </div>
            </div>
          )}

          {/* Info Parent */}
          {parentNodo && (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <div className="flex items-start">
                <InformationCircleIcon className="h-5 w-5 text-blue-500 mr-3 mt-0.5" />
                <div>
                  <h3 className="text-blue-800 font-medium">Nodo Genitore</h3>
                  <p className="text-blue-600 text-sm mt-1">
                    Questo nodo verrà creato sotto <strong>{parentNodo.nome}</strong> ({getTipoNodo(parentNodo.tipo).nome})
                  </p>
                </div>
              </div>
            </div>
          )}

          {renderFormModifica()}
        </form>
      </div>
    </div>
  );
};

export default GestoreNodi; 